import _Number$isNaN from "@babel/runtime-corejs2/core-js/number/is-nan";
/**
 * Convert string to Date object
 * @param { Date | string | number } date
 */

var stringToDateArray = function stringToDateArray(date) {
  var dateObj = new Date(date);

  if (_Number$isNaN(dateObj.getHours())) {
    return 'Invalid Date.';
  }

  return [dateObj.getFullYear(), dateObj.getMonth(), dateObj.getDate(), dateObj.getHours(), dateObj.getMinutes(), dateObj.getSeconds(), dateObj.getMilliseconds()];
};

export default stringToDateArray;